import type { FC, MouseEventHandler } from "react";

import { Link } from "../../utils/routing/components/Link";

import { type TrackingProps, trackEvent } from "utils/amplitude";
import { type LinkProps } from "utils/routing";

export type TrackedLinkProps = LinkProps & TrackingProps;

/*
 * A tracked link component that adds tracking to the onClick event.
 * This component is used to track link clicks for analytics purposes.
 *
 * @param {TrackedLinkProps} props - The props for the TrackedLink component.
 * @returns {JSX.Element} The rendered TrackedLink component.
 */
export const TrackedLink: FC<TrackedLinkProps> = ({
  eventName,
  eventProps = {},
  onClick,
  ...props
}) => {
  const clickHandler: MouseEventHandler<HTMLAnchorElement> | undefined = eventName
    ? (e) => {
        trackEvent(eventName, { eventCategory: "Button press", ...eventProps });
        if (onClick) {
          onClick(e);
        }
      }
    : onClick;

  return <Link {...props} onClick={clickHandler} />;
};
